import React from 'react';
import CredentialsView from './components/CredentialsView';
import { useCredentialsController } from './hooks/useCredentialsController';
import type { CredentialsProps } from './types';

/**
 * Credentials settings page component.
 *
 * Manages company-scoped API-key / OAuth credentials used by outbound
 * integrations (e.g. Logiblocks' Call Webhook node) -- create, rotate, and
 * delete. Never displays a saved secret's value.
 *
 * @param title - Page title to display
 */
const Credentials: React.FC<CredentialsProps> = ({ title }) => {
  const controller = useCredentialsController();

  return <CredentialsView controller={controller} title={title} />;
};

export default Credentials;
